import { pr } from '@/utils/pxToRem';
import { Typography, Stack } from '@mui/material';
import React from 'react';
import { style } from '@/styles/globals';
import Image from 'next/image';
import { loaderImageVex } from '@/utils/loadImageSeoVex';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const Certification = ({ lang }: { lang: ILangObj }) => (
  <Stack spacing={pr`16px`}>
    <Typography
      component="div"
      sx={{
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '30px',
        color: `${style.color.black1}`,
      }}
    >
      {lang?.footer?.certification || 'Chứng nhận'}
    </Typography>
    <Stack
      spacing={pr`23px`}
      marginTop={pr`23px`}
    >
      <Stack
        spacing={pr`10px`}
        flexWrap="wrap"
        justifyContent="flex-start"
        direction="row"
      >

        <div>
          <a href="http://online.gov.vn/Home/AppDetails/462">

            <Image
              loader={loaderImageVex}
              src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/c1.svg"
              alt="logo"
              width="104px"
              height="40px"
              objectFit="contain"
            />
          </a>
        </div>

        <div>
          <a href="http://online.gov.vn/Home/WebDetails/70277">
            <Image
              loader={loaderImageVex}
              src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/c2.svg"
              alt="logo"
              width="104px"
              height="40px"
              objectFit="contain"
            />
          </a>
        </div>
      </Stack>
      <Stack
        spacing={pr`10px`}
        flexWrap="wrap"
        justifyContent="flex-start"
        direction="row"
      >

        <div>
          <Image
            loader={loaderImageVex}
            src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/c3.svg"
            alt="logo"
            width="104px"
            height="40px"
            objectFit="contain"
          />

        </div>
        <div>
          <Image
            loader={loaderImageVex}
            src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/c4.svg"
            alt="logo"
            width="104px"
            height="40px"
            objectFit="contain"
          />

        </div>
      </Stack>
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="flex-start"
        spacing={pr`10px`}
      >

        <div>
          <Image
            loader={loaderImageVex}
            src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/c5.svg"
            alt="logo"
            width="104px"
            height="40px"
            objectFit="contain"
          />

        </div>
        <div>

          <Image
            loader={loaderImageVex}
            src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/c6.svg"
            alt="logo"
            width="104px"
            height="40px"
            objectFit="contain"
          />
        </div>
      </Stack>
    </Stack>
  </Stack>
);

export default Certification;
